// src/pages/Appli/PresenceAdmin/Users/components/UsersFilters.jsx
import React from "react";

export function UsersFilters({
  searchTerm, setSearchTerm,
  selectedRole, setSelectedRole,
  roles,
  sortBy, setSortBy,
  sortDir, setSortDir,
  viewMode, setViewMode,
  totalCount
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
      <input
        className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        type="text"
        placeholder="Rechercher (nom, email, club)…"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <select
        className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={selectedRole}
        onChange={(e) => setSelectedRole(e.target.value)}
      >
        <option value="">Tous les rôles</option>
        {roles.map((r) => (
          <option key={r.id} value={r.id}>{r.label}</option>
        ))}
      </select>

      <select
        className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
      >
        <option value="name">Trier par Nom</option>
        <option value="date">Trier par Date</option>
      </select>

      <select
        className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={sortDir}
        onChange={(e) => setSortDir(e.target.value)}
      >
        <option value="asc">Ascendant</option>
        <option value="desc">Descendant</option>
      </select>

      <div className="flex items-center gap-2">
        <button
          onClick={() => setViewMode("table")}
          className={`px-3 py-2 rounded-lg border text-sm ${viewMode === "table" ? "bg-slate-100 dark:bg-slate-800" : "bg-white dark:bg-slate-900"} border-slate-200 dark:border-slate-700`}
        >
          Table
        </button>
        <button
          onClick={() => setViewMode("cards")}
          className={`px-3 py-2 rounded-lg border text-sm ${viewMode === "cards" ? "bg-slate-100 dark:bg-slate-800" : "bg-white dark:bg-slate-900"} border-slate-200 dark:border-slate-700`}
        >
          Cartes
        </button>
      </div>

      <div className="flex items-center justify-end text-sm text-slate-500">
        {totalCount} résultat{totalCount > 1 ? "s" : ""}
      </div>
    </div>
  );
}
